/**
 * 相关文献列表默认数据（接口未返回时使用）
 */
export const literatureTabs = [
    { type: 'journal', label: '期刊论文', count: 92 },
    { type: 'degree', label: '学位论文', count: 6 },
    { type: 'conference', label: '会议论文', count: 4 },
];

export const literatureList = [
    {
        type: 'conference',
        typeLabel: '【会议论文】',
        title: '中医体质学理论构建与临床应用研究',
        author: '王琦',
        institution: '北京中医药大学',
        year: '2010',
        abstract: '本文系统梳理了中医体质学的理论渊源与发展脉络，探讨体质辨识在公共卫生与预防医学中的应用价值，并结合临床案例分析了体质分型指导个体化诊疗的实践路径……',
        keywords: ['中医基础理论', '体质辨识', '公共卫生'],
    },
    {
        type: 'conference',
        typeLabel: '【会议论文】',
        title: '基于数据挖掘的中医证候规律研究',
        author: '李建生',
        institution: '河南中医药大学',
        year: '2012',
        abstract: '运用数据挖掘方法对历代医籍及现代临床文献中的证候描述进行频次统计与关联分析，归纳核心证候要素及其组合规律，为证候标准化研究提供参考……',
        keywords: ['数据挖掘', '中医证候', '规律研究'],
    },
    {
        type: 'journal',
        typeLabel: '【期刊论文】',
        title: '中医药防治慢性病的研究进展',
        author: '张伯礼',
        institution: '天津中医药大学',
        year: '2018',
        abstract: '综述近年来中医药在高血压、糖尿病等慢性病防治领域的研究进展，分析复方、针灸及体质调理等干预手段的临床证据与作用机制……',
        keywords: ['中医药', '慢性病', '研究进展'],
    },
];
